export default __webpack_public_path__ + "a08367d27a04c28c0c8b5b7df1fcccfc.png";